export interface TypeOfCare {
	id: number;
	integrationOfficeId: number;
	remark: string;
	initial: string;
}

export const NO_INTEGRATION_OFFICE = -1;
export const NO_TYPE_OF_CARE = -1;

export enum TYPE_OF_CARE {
	// Main assignment
	Placement = 'Vermittlung',
	Safeguarding = 'Sicherung',
	SchoolToWork = 'Übergang Schule-Beruf',
	WorkshopToLaborMarket = 'Übergang Werkstatt-allgemeiner Arbeitsmarkt',

	// Additional assignment
	JobCoachingVision = 'Jobcoaching  Sehen',
	JobCoachingHearing = 'Jobcoaching  Hören',
	PsychologicalSupportHearing = 'psycholog. Begleitung Hören',
	SupportAssignmentHearing = 'Unterstützungsauftrag Hören',
	SupportAssignmentMEH = 'Unterstützungsauftrag MEH',
	SupportAssignmentVision = 'Unterstützungsauftrag Sehen',

	// FDS
	ProfessionalAssessment = 'Fachdienstliche Stellungnahme',
}

export const typeOfCareToShort: Record<TYPE_OF_CARE, string> = {
	// Main assignment
	[TYPE_OF_CARE.Placement]: 'VM',
	[TYPE_OF_CARE.Safeguarding]: 'SG',
	[TYPE_OF_CARE.SchoolToWork]: 'ÜSB',
	[TYPE_OF_CARE.WorkshopToLaborMarket]: 'ÜWA',

	// Additional assignment
	[TYPE_OF_CARE.JobCoachingVision]: 'JC-U-SE',
	[TYPE_OF_CARE.JobCoachingHearing]: 'JC-U-HB',
	[TYPE_OF_CARE.PsychologicalSupportHearing]: 'PHB',
	[TYPE_OF_CARE.SupportAssignmentHearing]: 'SG-U-HB',
	[TYPE_OF_CARE.SupportAssignmentMEH]: 'SG-U-MeH',
	[TYPE_OF_CARE.SupportAssignmentVision]: 'SG-U-SE',

	// FDS
	[TYPE_OF_CARE.ProfessionalAssessment]: 'FDS',
};
